import { useState } from "react";

export default function Provider() {
  const [service, setService] = useState("");
  const [price, setPrice] = useState("");
  const [time, setTime] = useState("");
  const [experience, setExperience] = useState("");

  const [services, setServices] = useState([]);

  const addService = () => {
    if (!service) return;

    const newService = { service, price, time, experience };
    setServices([...services, newService]);

    setService("");
    setPrice("");
    setTime("");
    setExperience("");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black text-white">

      {/* 🔥 NAVBAR */}
      <div className="flex justify-between items-center px-10 py-5 bg-white/5 backdrop-blur border-b border-white/10 sticky top-0">
        <h1 className="text-2xl font-bold text-blue-400">
          Fixado 🛠️
        </h1>

        <span className="text-gray-400">
          Provider Dashboard
        </span>
      </div>

      {/* 🔥 MAIN CONTENT */}
      <div className="p-10">

        {/* HEADER */}
        <h1 className="text-4xl mb-2 font-bold">
          Welcome, Provider 👋
        </h1>

        <p className="text-gray-400 mb-8">
          Add your services and start earning with Fixado
        </p>

        {/* FORM */}
        <div className="bg-white/10 p-6 rounded-2xl mb-10 backdrop-blur-xl border border-white/10">

          <h2 className="text-2xl mb-4">Add New Service</h2>

          <input
            placeholder="Service Name (e.g. AC Repair)"
            value={service}
            onChange={(e) => setService(e.target.value)}
            className="block mb-3 p-3 w-full text-black rounded-lg"
          />

          <input
            placeholder="Price (₹)"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            className="block mb-3 p-3 w-full text-black rounded-lg"
          />

          <input
            placeholder="Time (e.g. 2 hrs)"
            value={time}
            onChange={(e) => setTime(e.target.value)}
            className="block mb-3 p-3 w-full text-black rounded-lg"
          />

          <input
            placeholder="Experience (e.g. 3 years)"
            value={experience}
            onChange={(e) => setExperience(e.target.value)}
            className="block mb-4 p-3 w-full text-black rounded-lg"
          />

          <button
            onClick={addService}
            className="bg-blue-500 hover:bg-blue-600 px-6 py-3 rounded-xl font-semibold"
          >
            Add Service
          </button>
        </div>

        {/* 🔥 SERVICES LIST */}
        <h2 className="text-3xl mb-6">Your Services</h2>

        <div className="grid md:grid-cols-3 gap-6">

          {services.length === 0 && (
            <p className="text-gray-400">
              No services added yet...
            </p>
          )}

          {services.map((s, i) => (
            <div
              key={i}
              className="bg-white/10 p-6 rounded-2xl backdrop-blur-xl border border-white/10 hover:scale-105 transition"
            >
              <h3 className="text-xl font-semibold mb-2">
                {s.service}
              </h3>

              <p className="text-gray-300">💰 Price: {s.price}</p>
              <p className="text-gray-300">⏱ Time: {s.time}</p>
              <p className="text-gray-300">⭐ Experience: {s.experience}</p>
            </div>
          ))}

        </div>

      </div>

      {/* 🔥 FOOTER */}
      <div className="text-center py-6 border-t border-white/10 text-gray-400">
        © 2026 Fixado Services 🌍 | Empowering Providers
      </div>

    </div>
  );
}